import { render } from "./KnightOrSwiftToggle.vue?vue&type=template&id=4b4d1d34&scoped=true"
import script from "./KnightOrSwiftToggle.vue?vue&type=script&lang=js"
export * from "./KnightOrSwiftToggle.vue?vue&type=script&lang=js"

import "./KnightOrSwiftToggle.vue?vue&type=style&index=0&id=4b4d1d34&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b4d1d34"]])

export default __exports__